import ProductScroll from "../ProductScroll/ProductScroll";
export default function ProductListShop({
  itemsList,
  shopIsOpen,
  setIsOpenDrawerClose,
  shopId,
  hasMoreText = true,
}) {
  return (
    <div>
      {itemsList.map((value) => {
        return (
          <div className="mr-b-24 pd-b-16">
            {value.items.length > 0 && (
              <ProductScroll
                title={value.title}
                hasMoreText={hasMoreText}
                productList={value.items}
                shopIsOpen={shopIsOpen}
                setIsOpenDrawerClose={setIsOpenDrawerClose}
                index={value.index}
                shopId={shopId}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
